import windFullImg from '@/assets/images/layer-details/wind-forecast.jpg'
import windThumbImg from '@/assets/images/layer-wind-forecast.png'

export const WIND_LAYER_INFO = {
  id: 'wind',
  label: 'Wind Forecast',
  byline: 'See wind speed and direction over water',
  component: 'wind-forecast',
  img: windThumbImg,
  fullImg: windFullImg,
  hasAccess: true,
}

export const FHS_LAYER_INFO = { id: 'fhs_areas' }
